import * as Yup from "yup";

/**
 * Constrói um Yup.ObjectSchema a partir dos fields do plugin.
 * Mesma lógica do backend (buildYupSchema.ts).
 */
export function buildYupSchemaFromFields(fields) {
  const shape = {};
  const modelFields = new Set(["token", "name"]);

  for (const field of fields) {
    if (modelFields.has(field.name)) continue;

    let schema;

    if (field.type === "number") {
      schema = Yup.number().typeError(`${field.label} deve ser um número`);
    } else if (field.type === "switch") {
      schema = Yup.boolean();
    } else {
      schema = Yup.string();
    }

    const v = field.validation;
    if (v) {
      if (v.required) {
        const msg = typeof v.required === "string" ? v.required : `${field.label} é obrigatório`;
        schema = schema.required(msg);
      }

      if (v.min !== undefined) {
        const [val, msg] = Array.isArray(v.min) ? v.min : [v.min, undefined];
        schema = schema.min(val, msg || `${field.label} deve ter no mínimo ${val}`);
      }

      if (v.max !== undefined) {
        const [val, msg] = Array.isArray(v.max) ? v.max : [v.max, undefined];
        schema = schema.max(val, msg || `${field.label} deve ter no máximo ${val}`);
      }

      if (v.matches !== undefined && field.type !== "number" && field.type !== "switch") {
        const [pattern, msg] = Array.isArray(v.matches) ? v.matches : [v.matches, undefined];
        schema = schema.matches(new RegExp(pattern), msg || `${field.label} está em formato inválido`);
      }

      if (v.email && field.type !== "number" && field.type !== "switch") {
        const msg = typeof v.email === "string" ? v.email : "Email inválido";
        schema = schema.email(msg);
      }

      if (v.url && field.type !== "number" && field.type !== "switch") {
        const msg = typeof v.url === "string" ? v.url : "URL inválida";
        schema = schema.url(msg);
      }

      if (v.oneOf && field.type !== "number" && field.type !== "switch") {
        schema = schema.oneOf(v.oneOf, `${field.label} deve ser um dos valores: ${v.oneOf.join(", ")}`);
      }
    }

    shape[field.name] = schema;
  }

  return Yup.object().shape(shape);
}

/**
 * Valida dados contra fields do plugin usando Yup.
 * Retorna { valid, errors } para uso direto no formulário.
 */
export default async function validateFieldSchema(fields, data) {
  const schema = buildYupSchemaFromFields(fields);

  try {
    await schema.validate(data, { abortEarly: false });
    return { valid: true, errors: {} };
  } catch (err) {
    const errors = {};
    if (err.inner) {
      for (const e of err.inner) {
        if (e.path && !errors[e.path]) {
          errors[e.path] = e.message;
        }
      }
    }
    return { valid: false, errors };
  }
}
